import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Spinner } from "../components/common";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("As senhas não coincidem");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida! Faça login com a nova senha.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-scene" />
      <div className="glass rounded-3xl p-8 w-full max-w-md anim-fade-up">
        <h1 className="font-display text-xl font-bold text-white mb-2">Nova senha</h1>
        {!token ? (
          <p className="text-sm text-slate-400" data-testid="reset-invalid-token">Link inválido. Solicite uma nova redefinição.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-4">
            <div>
              <label className="text-xs font-mono2 uppercase tracking-widest text-slate-400 block mb-2">Nova senha</label>
              <input data-testid="reset-password-input" type="password" className="input-dark w-full rounded-xl px-4 py-3 text-sm" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
            </div>
            <div>
              <label className="text-xs font-mono2 uppercase tracking-widest text-slate-400 block mb-2">Confirmar senha</label>
              <input data-testid="reset-confirm-input" type="password" className="input-dark w-full rounded-xl px-4 py-3 text-sm" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} />
            </div>
            <button data-testid="reset-submit-btn" disabled={loading} className="btn-neon w-full py-3.5 rounded-xl text-sm flex items-center justify-center gap-2">
              {loading ? <Spinner /> : "Redefinir senha"}
            </button>
          </form>
        )}
        <div className="text-center mt-5">
          <Link to="/login" className="text-xs text-slate-500 hover:text-slate-300">← Voltar para o login</Link>
        </div>
      </div>
    </div>
  );
}
